import { render, staticRenderFns } from "./AdminRules.vue?vue&type=template&id=08882bc0&scoped=true"
import script from "./AdminRules.vue?vue&type=script&lang=js"
export * from "./AdminRules.vue?vue&type=script&lang=js"
import style0 from "./AdminRules.vue?vue&type=style&index=0&id=08882bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08882bc0",
  null
  
)

export default component.exports